import React from 'react'

interface Props {}

const PhysicalCount = (props: Props) => {
  return (
    <div>PhysicalCount</div>
  )
}

export default PhysicalCount